import { render, staticRenderFns } from "./ManagerCategorization.vue?vue&type=template&id=79f75196&scoped=true&"
import script from "./ManagerCategorization.vue?vue&type=script&lang=js&"
export * from "./ManagerCategorization.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-categorization.scss?vue&type=style&index=0&id=79f75196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f75196",
  null
  
)

export default component.exports